import axios from "axios";
import { BACKEND_URL } from "../../utils/informationUtility";

// user api
const API = axios.create({
  baseURL: "/api/user",
});

// developer api
const DevAPI = axios.create({
  baseURL: "/api/developer",
});

// register
const register = async (userData) => {
  try {
    const response = await API.post("/register", userData);

    if (response.data) {
      const { token, ...user } = response.data;
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", JSON.stringify(token));
      return { user };
    } else {
      // Server responded with no data
      return Promise.reject(
        new Error(response.error || "Registration failed.")
      );
    }
  } catch (error) {
    // Optionally log the error
    console.error("Registration error:", error);
    // Reject so caller can handle/display
    return Promise.reject(new Error(error.response.data.error));
  }
};

//Update password
const updateAccountDetails = async ({ userDetails, token }) => {
  const userData = {
    password: userDetails.newPassword,
    //oldPassword: userDetails.oldPassword,
  };
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const member_id = userDetails.member_id;
  const user_email = userDetails.user_email;

  try {
    const response = await API.post(
      `/edit_password/${member_id}/${user_email}`,
      userData
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// dev function to update user privilige level -> change to -> update user details
const updateUserPersonal = async ({ data, token }) => {
  const user_id = data.user_id;
  const userDetails = data.userDetails; // Ensure you have the member ID
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  try {
    const response = await API.post(`edit/${user_id}`, userDetails, {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the headers if required
      },
    });
    return response.data;
  } catch (error) {
    return error.response ? error.response.data : { error: "Network Error" };
  }
};

const getUser = async (id, token) => {
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await API.get(`/${id}`, config);
    return response.data;
  } catch (error) {
    return error;
  }
};

const login = async (user) => {
  const { email, password } = user;
  const response = await API.post(
    "/login",
    { email, password },
    { headers: { "Content-Type": "application/json" } }
  );

  localStorage.setItem("user", JSON.stringify(response.data));
  localStorage.setItem("token", JSON.stringify(response.data.token));

  const result = {
    user: response.data,
    token: response.data.token,
  };
  return result;
};

// // get_usage
// const get_usage = async (user) => {
//   let token = JSON.parse(localStorage.getItem("token"));
//   const config = {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   };

//   const response = await API.get(`/usage/${user}`, config);

//   return response.data;
// };

// generate api key
const generateApi = async (data) => {
  const { orgId, bot_id } = data;
  let token = JSON.parse(localStorage.getItem("token"));
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await DevAPI.get(`/generate/${orgId}/${bot_id}`, config);

  return response.data;
};

// delete api key
const deleteApi = async (key) => {
  let token = JSON.parse(localStorage.getItem("token"));
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const response = await DevAPI.delete(`/delete`, { apiKey: key }, config);
  return response.data;
};

// generate verificaion token
const generateVerificationToken = async (data) => {
  let token = JSON.parse(localStorage.getItem("token"));
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const response = await API.post(
    `/generate/verification_token`,
    { email: data.email },
    config
  );
  return response.data;
};

// generate verificaion token
const deleteVerificationToken = async (data) => {
  let token = JSON.parse(localStorage.getItem("token"));
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const response = await API.post(
    `/delete/verification_token`,
    { email: data.email },
    config
  );
  return response.data;
};

const resetUserPassword = async (data) => {
  let token = JSON.parse(localStorage.getItem("token"));
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  const email = data.user_email;
  const dataObj = {
    password: data.password,
  };

  const response = await API.post(
    `/edit_user_password/${email}`,
    dataObj,
    config
  );
  return response.data;
};

//Update updateFirstTimeUser
const updateFirstTimeUser = async ({ userDetails }) => {
  let token = JSON.parse(localStorage.getItem("token"));
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  const userData = {
    status: userDetails.status,
  };
  const user_id = userDetails.user_id;

  try {
    const response = await API.post(
      `update_first_time_user/${user_id}`,
      userData,
      config
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

const getUserBotMemory = async (data, token) => {
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { user_id, bot_id } = data;

  try {
    const response = await API.get(`memory/${user_id}/${bot_id}`, config);
    if (!response.status.toString().startsWith("2")) {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching bot memory:", error);
    throw error;
  }
};

const getOTP = async (data, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const { email, first_name } = data;

  try {
    const response = await API.post(
      `/send_invitation_email/${email}`,
      { first_name: first_name },
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bot memory:", error);
    throw error;
  }
};

const forgetPassword = async (data, token) => {
  // if (!token) {
  //   token = JSON.parse(localStorage.getItem("token"));
  // }
  // if (!token) {
  //   const __USER__ = JSON.parse(localStorage.getItem("user"));
  //   token = __USER__.token;
  // }
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const { email, password } = data;

  try {
    const response = await API.post(
      `/user/reset_forgot_password/${email}`,
      { password: password },
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bot memory:", error);
    throw error;
  }
};

//bugReport
const _bugReport_ = async (data, token) => {
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await API.post(
      `/user/bug-report/${data.user_id}`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error sending bug report:", error);
    throw error;
  }
};

const createNewMemorySession = async (user_id, bot_id, sessionTitle, token) => {
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__.token;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await API.post(
      `/create/session/${user_id}/${bot_id}`,
      { query: sessionTitle },
      config
    );

    if (!response.status.toString().startsWith("2")) {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error("Error creating new memory session:", error);
    throw error;
  }
};

const getSession = async (session_id, token) => {
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await API.get(`/session/${session_id}`, config);
    if (!response.status.toString().startsWith("2")) {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching session:", error);
    throw error;
  }
};

const deleteSession = async (session_id, token) => {
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await API.delete(`/delete/session/${session_id}`, config);
    if (!response.status.toString().startsWith("2")) {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
    return { session_id };
  } catch (error) {
    console.error("Error deleting session:", error);
    throw error;
  }
};

const updateSessionTitle = async (data, token) => {
  if (!token) {
    token = JSON.parse(localStorage.getItem("token"));
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { session_id } = data;

  try {
    const response = await API.post(
      `/update_session_title/${session_id}`,
      data,
      config
    );
    if (!response.status.toString().startsWith("2")) {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
    return { session_id, title: data.title };
  } catch (error) {
    console.error("Error deleting session:", error);
    throw error;
  }
};

const UpdateCurrentUserPassword = async (data) => {
  let token = JSON.parse(localStorage.getItem("token"));
  if (!token) {
    const __USER__ = JSON.parse(localStorage.getItem("user"));
    token = __USER__?.token;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const email = data.user_email;
  const dataObj = {
    oldPassword: data.oldPassword,
    password: data.password,
    email,
  };

  const response = await API.post(`/reset_password`, dataObj, config);

  // Handle FastAPI's tuple-like response [data, status]
  if (Array.isArray(response.data) && response.data.length === 2) {
    const [result, statusCode] = response.data;

    if (statusCode !== 200) {
      // Throw error message for thunk to catch
      throw new Error(result?.status || "Password update failed.");
    }

    return result;
  }
};

export const getGoogleLoginUrl = () =>
  `${BACKEND_URL}/api/user/google/login?google_auth=true`;

export const getGoogleRegisterUrl = () =>
  `${BACKEND_URL}/api/user/google/register`;

const authService = {
  register,
  login,
  getUser,
  updateAccountDetails,
  updateUserPersonal,
  //get_usage,
  generateApi,
  deleteApi,
  generateVerificationToken,
  deleteVerificationToken,
  resetUserPassword,
  getUserBotMemory,
  getOTP,
  forgetPassword,
  updateFirstTimeUser,
  _bugReport_,
  createNewMemorySession,
  getSession,
  deleteSession,
  updateSessionTitle,
  UpdateCurrentUserPassword,
  getGoogleLoginUrl,
  getGoogleRegisterUrl,
};

export default authService;
